module.exports = __webpack_public_path__ + "assets/img/case-broker-list.df20d028.png";